var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useRef } from 'react';
import classNames from 'classnames';
import { BubbleLoader } from 'ziphy-web-shared/basic/lib/loaders';
import { ContentEditable } from 'ziphy-web-shared/basic/lib/simple';
import styles from './BadgeNew.module.scss';
const BadgeNew = forwardRef((_a, ref) => {
    var { id, valueId, value, placeholder, className, color = 'blue', editable = true, contentEditable = false, showTextSelection = true, isLoading = true, loadingPosition = 'center', onClick, onBlur, isPlain = false, isInvalid = false } = _a, rest = __rest(_a, ["id", "valueId", "value", "placeholder", "className", "color", "editable", "contentEditable", "showTextSelection", "isLoading", "loadingPosition", "onClick", "onBlur", "isPlain", "isInvalid"]);
    const valueRef = useRef(null);
    if (isPlain) {
        return (_jsxs("span", Object.assign({ id: id, ref: ref, contentEditable: false }, { children: [_jsx("span", Object.assign({ className: styles.value }, { children: value })), _jsx("span", Object.assign({ className: styles.placeholder }, { children: value ? '' : placeholder }))] })));
    }
    return (_jsxs("span", Object.assign({ id: id, ref: ref, contentEditable: false, className: classNames(styles.container, className, {
            [styles.containerPlaceholder]: !value,
            [styles.containerEditable]: editable,
            [styles.containerContentEditable]: contentEditable,
            [styles.containerPurple]: color === 'purple',
            [styles.containerGray]: color === 'gray',
            [styles.containerDisableSelection]: !showTextSelection,
            [styles.containerLoading]: isLoading,
            [styles.containerLoadingStart]: loadingPosition === 'start',
            [styles.containerInvalid]: isInvalid,
        }), onClick: onClick }, rest, { children: [contentEditable ? (_jsx(ContentEditable, { id: valueId, ref: valueRef, value: value, contentEditable: contentEditable, onBlur: onBlur })) : (_jsx("span", Object.assign({ id: valueId, className: styles.value }, { children: value }))), _jsx("span", Object.assign({ className: styles.loader }, { children: _jsx(BubbleLoader, { className: styles.bubbleLoader }) })), _jsx("span", Object.assign({ className: styles.placeholder, onClick: () => { var _a; return (_a = valueRef.current) === null || _a === void 0 ? void 0 : _a.focus(); } }, { children: value ? '' : placeholder }))] })));
});
export default BadgeNew;
